import { Injectable } from '@angular/core';
import { TimezoneService } from '@services/timezone.service';
import moment from 'moment-timezone';

@Injectable({
  providedIn: 'root',
})
export class UserDatetimeService {
  private userTimezone: string;

  constructor(private timezoneService: TimezoneService) {
    this.timezoneService.timezone.subscribe((tz) => (this.userTimezone = tz));
  }
  // do użycia na datetime przed wysłaniem do API
  convertToAPIDatetime(sourceDatetime: Date | string): string {
    if (sourceDatetime) {
      const sourceFormatted = moment(sourceDatetime).format('YYYY-MM-DD HH:mm:ss');
      const convertByTimezone = moment.tz(sourceFormatted, this.userTimezone);
      return convertByTimezone.utc().format('YYYY-MM-DD HH:mm:ss');
    }
    return null;
  }

  // po otrzymaniu datetime z API
  convertFromAPIDatetime(sourceDatetime: Date | string): Date {
    if (sourceDatetime) {
      const timezoneFormatted = moment.utc(sourceDatetime).tz(this.userTimezone).format('YYYY-MM-DD HH:mm:ss');
      return new Date(timezoneFormatted);
    }
    return null;
  }

  // przed wyslaniem daty do API
  convertToAPIDate(sourceDatetime: Date | string): string {
    if (sourceDatetime) {
      return moment(sourceDatetime).format('YYYY-MM-DD');
    }
    return null;
  }

  // po otrzymaniu daty z API, chcac ja uzyc np. w formularzu
  convertFromAPIDate(sourceDatetime: Date | string): string {
    if (sourceDatetime) {
      return moment(moment(sourceDatetime).format('YYYY-MM-DD HH:mm:ss')).utcOffset(0).format('YYYY-MM-DD HH:mm:ss');
    }
    return null;
  }

  //przed uzyciem daty w datepickerze gdzie używane są także godziny
  convertDateFromAPIDate(sourceDatetime: Date | string): string {
    if (sourceDatetime) {
      return moment.utc(sourceDatetime).tz(this.userTimezone).format('YYYY-MM-DD');
    }
    return null;
  }

  // po dacie z datepickera do końca dnia i wysłanie do API
  convertToAPIDatetimeEndDate(sourceDatetime: Date | string): string {
    if (sourceDatetime) {
      const sourceFormatted = moment(sourceDatetime)
        .set({ hour: 23, minute: 59, second: 59, millisecond: 999 })
        .format('YYYY-MM-DD HH:mm:ss');
      const convertByTimezone = moment.tz(sourceFormatted, this.userTimezone);
      return convertByTimezone.utc().format('YYYY-MM-DD HH:mm:ss');
    }
    return null;
  }
}
